import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c(
        "auto-suggest",
        _vm._b(
          {
            staticClass: "flex-grow-1",
            attrs: {
              icon: _vm.icon,
              showAddButton: false,
              suggestionText: "name",
              suggestionValue: "id",
              "return-object": "",
              label: _vm.searchFieldLabel,
            },
            on: { search: _vm.lookupLicensePlate, selected: _vm.selected },
            model: {
              value: _vm.companyVehicle,
              callback: function ($$v) {
                _vm.companyVehicle = $$v
              },
              expression: "companyVehicle",
            },
          },
          "auto-suggest",
          _vm.$attrs,
          false
        )
      ),
      _vm.allowAddVehicle
        ? _c(
            VBtn,
            {
              staticClass: "flex-shrink-1 mt-3 mx-2",
              attrs: {
                to: { name: "companyVehicleCreate" },
                color: "primary",
                icon: "",
              },
            },
            [_c(VIcon, [_vm._v("mdi-truck-plus")])],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }